import { IFavoritesFolder } from '../../types/favoriteEntity';
import { ITypedReduxAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux';

export enum EFoldersActionTypes {
  Add = 'FOLDERS :: ADD',
  Remove = 'FOLDERS :: REMOVE',
  Rename = 'FOLDERS :: RENAME',
  Set = 'FOLDERS :: SET',
  Select = 'FOLDERS :: SELECT',
  OpenModalRename = 'FOLDERS :: OPEN_MODAL_RENAME',
  CloseModalRename = 'FOLDERS :: CLOSE_MODAL_RENAME',
  OpenModalRemove = 'FOLDERS :: OPEN_MODAL_REMOVE',
  CloseModalRemove = 'FOLDERS :: CLOSE_MODAL_REMOVE',
  SetCanLoadMore = 'FOLDERS :: SET_CAN_LOAD_MORE',
  ShowUnsupportedModal = 'FOLDERS :: SHOW_UNSUPPORTED_MODAL',
  HideUnsupportedModal = 'FOLDERS :: HIDE_UNSUPPORTED_MODAL',
}

export interface IAddActionPayload {
  id: number;
  name: string;
}

export interface IRemoveActionPayload {
  id: number;
}

export interface IRenameActionPayload {
  id: number;
  name: string;
}

export interface ISetActionPayload {
  folders: IFavoritesFolder[];
}

export interface ISelectActionPayload {
  folder: IFavoritesFolder | null;
}

export interface ISetCanLoadMoreActionPayload {
  value: boolean;
}

export type TFoldersActions =
  | ITypedReduxAction<EFoldersActionTypes.Add, IAddActionPayload>
  | ITypedReduxAction<EFoldersActionTypes.Remove, IRemoveActionPayload>
  | ITypedReduxAction<EFoldersActionTypes.Rename, IRenameActionPayload>
  | ITypedReduxAction<EFoldersActionTypes.Set, ISetActionPayload>
  | ITypedReduxAction<EFoldersActionTypes.Select, ISelectActionPayload>
  | ITypedReduxAction<EFoldersActionTypes.OpenModalRename, void>
  | ITypedReduxAction<EFoldersActionTypes.OpenModalRemove, void>
  | ITypedReduxAction<EFoldersActionTypes.CloseModalRename, void>
  | ITypedReduxAction<EFoldersActionTypes.CloseModalRemove, void>
  | ITypedReduxAction<EFoldersActionTypes.SetCanLoadMore, ISetCanLoadMoreActionPayload>
  | ITypedReduxAction<EFoldersActionTypes.ShowUnsupportedModal, void>
  | ITypedReduxAction<EFoldersActionTypes.HideUnsupportedModal, void>;

export const addFolder: (payload: IAddActionPayload) => TFoldersActions = actionGenerator<
  EFoldersActionTypes.Add,
  IAddActionPayload
>(EFoldersActionTypes.Add);

export const removeFolder: (payload: IRemoveActionPayload) => TFoldersActions = actionGenerator<
  EFoldersActionTypes.Remove,
  IRemoveActionPayload
>(EFoldersActionTypes.Remove);

export const renameFolder: (payload: IRenameActionPayload) => TFoldersActions = actionGenerator<
  EFoldersActionTypes.Rename,
  IRenameActionPayload
>(EFoldersActionTypes.Rename);

export const setFolders: (payload: ISetActionPayload) => TFoldersActions = actionGenerator<
  EFoldersActionTypes.Set,
  ISetActionPayload
>(EFoldersActionTypes.Set);

export const selectFolder: (payload: ISelectActionPayload) => TFoldersActions = actionGenerator<
  EFoldersActionTypes.Select,
  ISelectActionPayload
>(EFoldersActionTypes.Select);

export const openModalRename: () => TFoldersActions = actionGenerator<EFoldersActionTypes.OpenModalRename>(
  EFoldersActionTypes.OpenModalRename,
);

export const openModalRemove: () => TFoldersActions = actionGenerator<EFoldersActionTypes.OpenModalRemove>(
  EFoldersActionTypes.OpenModalRemove,
);

export const closeModalRename: () => TFoldersActions = actionGenerator<EFoldersActionTypes.CloseModalRename>(
  EFoldersActionTypes.CloseModalRename,
);

export const closeModalRemove: () => TFoldersActions = actionGenerator<EFoldersActionTypes.CloseModalRemove>(
  EFoldersActionTypes.CloseModalRemove,
);

export const setCanLoadMore: (payload: ISetCanLoadMoreActionPayload) => TFoldersActions = actionGenerator<
  EFoldersActionTypes.SetCanLoadMore,
  ISetCanLoadMoreActionPayload
>(EFoldersActionTypes.SetCanLoadMore);

export const showUnsupportedModal: () => TFoldersActions = actionGenerator<EFoldersActionTypes.ShowUnsupportedModal>(
  EFoldersActionTypes.ShowUnsupportedModal,
);

export const hideUnsupportedModal: () => TFoldersActions = actionGenerator<EFoldersActionTypes.HideUnsupportedModal>(
  EFoldersActionTypes.HideUnsupportedModal,
);
